import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import {
    Box,
    IconButton,
    LinearProgress,
} from '@mui/material';
import {
    CheckCircleOutline,
    CancelOutlined,
    ErrorOutlineOutlined,
    OpenInNew,
} from '@mui/icons-material';
import {
    DataGridPro,
    LicenseInfo
} from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);

const renderAssetStatus = (params) => {
    return params.value === 1 ? (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ backgroundColor: 'rgb(76 175 80)', borderRadius: '50%', width: 24, height: 24 }}>
            <CheckCircleOutline />
        </Box>
    ) : params.value === 0 ? (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ backgroundColor: 'rgb(255, 213, 79)', borderRadius: '50%', width: 24, height: 24 }}>
            <ErrorOutlineOutlined />
        </Box>
    ) : (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ backgroundColor: 'rgb(239, 83, 80)', borderRadius: '50%', width: 24, height: 24 }}>
            <CancelOutlined />
        </Box>
    );
};

const renderDetailCell = (params, handleLabrollDetail) => {
    return (
        <IconButton
            variant="contained"
            sx={{
                color: 'rgba(255, 255, 255, 1)',
                '&:hover': {
                    color: 'rgb(76, 146, 107)',
                },
            }}
            onClick={() => {
                handleLabrollDetail(params.row);
            }}
        >
            <OpenInNew />
        </IconButton>
    );
};

export default function AssetDetailDataGrid(props) {
    const {
        handleLabrollDetail,
        retrieveAssetDetail,
        rows,
        rowsLoading,
        transferdate,
    } = props
    const { isAuthenticated } = useAuth0();

    const columns = [
            {field: 'transfer_date',        headerName: 'Transfer Date',        width: 250 },
            {field: 'status',               headerName: 'Status',                 width: 70, renderCell: renderAssetStatus },
            {field: 'labroll',              headerName: 'Labroll',              width: 110 },
            {field: 'camera',               headerName: 'Camera',               width: 180},
            {field: 'camera_type',          headerName: 'Camera Type',          width: 180},
            {field: 'shot_count',           headerName: 'Shot Count',           width: 180},
            {field: 'detected_camera_format', headerName: 'Detected Camera Format', width: 230},
            {field: 'duration',             headerName: 'Duration',             width: 120},
            {field: 'onset_filename',     headerName: 'OnSet Filename',     width: 320},
            {field: 'onset_size',         headerName: 'OnSet Size',         width: 180},
            {field: 'onset_date',         headerName: 'OnSet Date',         width: 180},
            {field: 'onset_shot_count',   headerName: 'OnSet Shot Count',   width: 180},
            {field: 'onset_volumes',      headerName: 'OnSet Volumes',      width: 280},
            {field: 'onset_link_ratio',   headerName: 'OnSet Link Ratio',   width: 180},
            {field: 'lab_filename',         headerName: 'Lab Filename',         width: 320},
            {field: 'lab_size',             headerName: 'Lab Size',             width: 180},
            {field: 'lab_date',             headerName: 'Lab Date',             width: 180},
            {field: 'lab_shot_count',       headerName: 'Lab Shot Count',       width: 180},
            {field: 'lab_volumes',          headerName: 'Lab Volumes',          width: 280},
            {field: 'lab_link_ratio',       headerName: 'Lab Link Ratio',       width: 180},
            {field: 'archive_filename',         headerName: 'Archive Filename',         width: 320},
            {field: 'archive_size',             headerName: 'Archive Size',             width: 180},
            {field: 'archive_date',             headerName: 'Archive Date',             width: 180},
            {field: 'archive_shot_count',       headerName: 'Archive Shot Count',       width: 180},
            {field: 'archive_volumes',          headerName: 'Archive Volumes',          width: 280},
            {field: 'archive_link_ratio',       headerName: 'Archive Link Ratio',       width: 180},
            {field: 'details',              headerName: '',                     width: 10, renderCell: (params) => renderDetailCell(params, handleLabrollDetail) }
        ];


    const handleRowDoubleClick = (params, event) => {
        event.stopPropagation()
        handleLabrollDetail(params.row);
    };

    useEffect(() => {
        isAuthenticated && (() => {
            retrieveAssetDetail({transfer_date: transferdate})
        })()
    }, [isAuthenticated, transferdate])

    return (
        <React.Fragment>
                <DataGridPro 
                    sx={{
                        backgroundColor: '#101010', // Change the background color of the data grid
                        borderColor: '#122218',
                        '& .MuiDataGrid-root': {
                            cursor: 'pointer', // Change the cursor to pointer when hovering over the data grid
                        },
                        '& .MuiDataGrid-cell:hover': {
                            color: 'rgb(76, 146, 107)',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            borderColor: 'green', // Make the separator green
                            borderWidth: '2px', // Set the thickness of the separator
                            visibility: 'visible', // Ensure the separator always visible
                            '&:hover': {
                                borderColor: 'rgb(76, 146, 107)', // Ensure the separator stays green on hover
                            },
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#101010', // Change the column header background to black
                        },
                        '& .MuiDataGrid-columnHeader': {
                            fontSize: '14px', // Customize the font size of the column headers
                            color: 'white', // Change the column header color to white
                            fontWeight: 'bold', // Make the column header text bold
                            borderBottom: 'None', // Change the bottom line color of the column headers
                        },
                        '& .MuiDataGrid-row': {
                            border: 'none', // Remove the row separator lines
                        },
                        '& .MuiDataGrid-rowCount': {
                            color: 'white', // Change the background color of the selected row
                        },
                        '& .MuiDataGrid-selectedRowCount': {
                            color: 'white', // Change the font color of the selected row count
                        },
                        '& .MuiDataGrid-cell': {
                            border: 'none', // Remove the cell separator lines
                            color: 'white', // Change the font color of the cells
                            fontSize: '13px', // Make the cell text smaller
                            userSelect: 'none'
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#161618', // Change the background color of odd rows
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#202020', // Change the background color of even rows
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: 'rgba(76, 146, 107, 0.1)', // Change the hover color of the row to light green with reduced opacity
                        },
                        '& .MuiDataGrid-cell--withRenderer': {
                            '& .MuiCheckbox-root': {
                                color: 'white', // Change the color of the checkbox
                                transform: 'scale(0.7)', // Make the checkbox smaller
                                '& .MuiSvgIcon-root': {
                                    borderRadius: '50%', // Make the checkbox a circle
                                },
                                '&.Mui-checked': {
                                    color: '#54a277', // Change the color of the selected checkbox to green
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderCheckbox': {
                            '& .MuiCheckbox-root': {
                                color: 'white', // Change the color of the checkbox in the column header
                                transform: 'scale(0.8)', // Make the checkbox smaller in the column header
                                '& .MuiSvgIcon-root': {
                                    borderRadius: '50%', // Make the checkbox a circle in the column header
                                },
                                '&.Mui-checked': {
                                    color: '#54a277', // Change the color of the selected checkbox to green in the column header
                                },
                            },
                        },
                    }}
                    components={{
                        LoadingOverlay: LinearProgress,
                    }}
                    columns={columns}
                    loading={rowsLoading}
                    onRowDoubleClick={handleRowDoubleClick}
                    pageSize={4}
                    rows={rows}
                />
        </React.Fragment>
    )
 }
